/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { itemClasses } from '../themes/classes';
import {
  PopupDialog,
  dublicateAlert,
  errorAlert,
  successAlert,
} from '../Shared';
import AutoFieldLocal from '../components/fields/AutoFieldLocal';
import useTasks from '../hooks/useTasks';
import { useEmployees, useTemplate } from '../hooks';
import { AlertLocal, CalenderLocal } from '../components';

export const indexTheList = (list: any) => {
  return list.map((item: any, index: any) => {
    return {
      ...item,
      index,
    };
  });
};

const PopupOvertime = ({
  open,
  onClose,
  row,
  isNew,
  addAction,
  editAction,
  isRTL,
  words,
}: any) => {
  const classes = itemClasses();
  const [desc, setDesc] = useState('');
  const [saving, setSaving] = useState(false);
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });
  const [selectedDate, setSelectedDate] = React.useState(new Date());

  const [emplvalue, setEmplvalue] = useState<any>(null);
  const [taskvalue, setTaskvalue] = useState<any>(null);
  const [overtime, setOvertime] = useState(0);
  const [deduction, setDeduction] = useState(0);
  const [bonos, setBonos] = useState(0);

  const { tasks } = useTasks();

  const { tempwords } = useTemplate();
  const { employeesfull: employees } = useEmployees();

  const { register, handleSubmit, errors } = useForm();

  const handleDateChange = (date: any) => {
    if (date) {
      const d = new Date(date);
      setSelectedDate(d);
    }
  };

  useEffect(() => {
    if (row && row._id) {
      const empId = row?.employeeId;
      const contractId = row?.contractId;
      if (contractId) {
        const tsk = tasks.filter((ts: any) => ts._id === contractId)[0];
        setTaskvalue(tsk);
      }
      if (empId) {
        const empl = employees.filter((emp: any) => emp._id === empId)[0];
        setEmplvalue(empl);
      }
      setOvertime(row.overtime);
      setDeduction(row.deduction);
      setBonos(row.bonos);
      setDesc(row?.desc);
      handleDateChange(row?.time);
    }
  }, [open]);

  const resetAll = () => {
    setEmplvalue(null);
    setTaskvalue(null);
    setOvertime(0);
    setDeduction(0);
    setBonos(0);
    setDesc('');
  };

  const onError = async (error: any) => {
    if (error.message.includes('duplicate')) {
      await dublicateAlert(setAlrt, isRTL);
    } else {
      await errorAlert(setAlrt, isRTL);
      console.log(error);
    }
  };

  const onSubmit = async () => {
    setSaving(true);

    const variables: any = {
      _id: row && row._id ? row._id : undefined, // is it new or edit
      time: selectedDate,
      bonos,
      overtime,
      deduction,
      desc,
      employeeId: emplvalue?._id,
      employeeName: emplvalue?.name,
      employeeNameAr: emplvalue?.nameAr,
      departmentId: emplvalue?.departmentId,
      departmentName: emplvalue?.departmentName,
      departmentNameAr: emplvalue?.departmentNameAr,
      contractId: taskvalue?._id,
      contractName: taskvalue?.name,
      contractNameAr: taskvalue?.nameAr,
    };
    const mutate = isNew ? addAction : editAction;
    const mutateName = isNew ? 'createHritem' : 'updateHritem';
    await apply(mutate, mutateName, variables);
  };

  const apply = async (mutate: any, mutateName: string, variables: any) => {
    try {
      const res = await mutate({ variables });
      if (res?.data?.[mutateName]?.ok === false) {
        await errorAlert(setAlrt, isRTL);
        setSaving(false);
        return;
      }
      setSaving(false);
      await successAlert(setAlrt, isRTL);
      onFormClose();
    } catch (error) {
      setSaving(false);
      onError(error);
    }
  };

  const onHandleSubmit = () => {
    handleSubmit(onSubmit)();
  };
  const onFormClose = () => {
    onClose();
    resetAll();
    setSaving(false);
  };

  return (
    <PopupDialog
      open={open}
      onClose={onFormClose}
      maxWidth={'lg'}
      classes={classes}
    >
      <Box
        display="flex"
        style={{
          flex: 1,
          margin: 20,
          direction: isRTL ? 'rtl' : 'ltr',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CalenderLocal
              isRTL={isRTL}
              label={words?.time}
              value={selectedDate}
              onChange={handleDateChange}
            ></CalenderLocal>
          </Grid>
          <Grid item xs={5}>
            <AutoFieldLocal
              name="employee"
              title={tempwords?.employee}
              words={words}
              options={employees.filter((emp: any) => !emp.disabled)}
              value={emplvalue}
              setSelectValue={setEmplvalue}
              isRTL={isRTL}
              fullWidth
              mb={0}
            ></AutoFieldLocal>
          </Grid>
          <Grid item xs={4}>
            <AutoFieldLocal
              name="task"
              title={tempwords?.task}
              words={words}
              options={tasks}
              value={taskvalue}
              setSelectValue={setTaskvalue}
              isRTL={isRTL}
              fullWidth
              mb={0}
            ></AutoFieldLocal>
          </Grid>
          <Grid item xs={3}></Grid>
          <Grid item xs={3}>
            <TextField
              name="overtime"
              onChange={(e: any) => setOvertime(Number(e.target.value))}
              value={overtime}
              label={isRTL ? 'اضافي' : 'Overtime'}
              error={errors.price ? true : false}
              variant="outlined"
              inputRef={register}
              type="number"
              fullWidth
              margin="dense"
              onFocus={(e) => e.target.select()}
              // inputProps={{
              //   style: { textAlign: 'right' },
              //   inputMode: 'decimal',
              // }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              name="bonos"
              onChange={(e: any) => setBonos(Number(e.target.value))}
              value={bonos}
              label={isRTL ? 'مكافئة' : 'Bonos'}
              error={errors.price ? true : false}
              variant="outlined"
              inputRef={register}
              type="number"
              fullWidth
              margin="dense"
              onFocus={(e) => e.target.select()}
              // inputProps={{
              //   style: { textAlign: 'right' },
              //   inputMode: 'decimal',
              // }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              name="deduction"
              onChange={(e: any) => setDeduction(Number(e.target.value))}
              value={deduction}
              label={isRTL ? 'خصم' : 'Deduction'}
              error={errors.price ? true : false}
              variant="outlined"
              inputRef={register}
              type="number"
              fullWidth
              margin="dense"
              onFocus={(e) => e.target.select()}
              // inputProps={{
              //   style: { textAlign: 'right' },
              //   inputMode: 'decimal',
              // }}
            />
          </Grid>
          <Grid item xs={12}>
            <div>
              <TextField
                name="desc"
                onChange={(e: any) => setDesc(e.target.value)}
                value={desc}
                label={words?.description}
                variant="outlined"
                margin="dense"
                onFocus={(e) => e.target.select()}
                fullWidth
                multiline
                rowsMax={2}
                rows={2}
                style={{ marginTop: 0 }}
              />
            </div>
          </Grid>
          {alrt?.show && (
            <AlertLocal
              isRTL={isRTL}
              type={alrt?.type}
              msg={alrt?.msg}
            ></AlertLocal>
          )}
          <Grid item xs={2}>
            <Button
              style={{ minWidth: 100 }}
              color="primary"
              onClick={onHandleSubmit}
              variant="contained"
            >
              <Typography>{isRTL ? 'حفظ' : 'Save'}</Typography>
              {saving && (
                <CircularProgress
                  style={{ position: 'absolute' }}
                  color="primary"
                  size={16}
                />
              )}
            </Button>
          </Grid>
          <Grid item xs={2}>
            <Button
              style={{ minWidth: 100 }}
              color="primary"
              onClick={onFormClose}
              variant="outlined"
            >
              <Typography>{isRTL ? 'اغلاق' : 'Close'}</Typography>
            </Button>
          </Grid>
        </Grid>
      </Box>
    </PopupDialog>
  );
};

export default PopupOvertime;
